import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerDocumentForm from '../containers/PlannerDocumentFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerDocumentEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerDocumentEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_documents_route_edit')} />
          <PlannerDocumentForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerDocumentEditScreen;

Logger.log('silly', `PlannerDocumentEditScreen loaded.`);
